export enum IntendedRecipient {    
    Relative = 1,
    NonRelative = 2,
    SocialMedia = 3,
    Anyone = 4
}